document.addEventListener(
  "DOMContentLoaded",
  () => {

    const cards =
      document.querySelectorAll(
        "#placement-grid .option-card"
      );

    const hidden =
      document.getElementById(
        "placementType"
      );

    cards.forEach(card => {

      card.addEventListener(
        "click",
        () => {

          cards.forEach(c =>
            c.classList.remove("active")
          );

          card.classList.add(
            "active"
          );

          hidden.value =
            card.dataset.placement;

          document.dispatchEvent(
            new CustomEvent(
              "embroideryUpdated"
            )
          );

        }
      );

    });

  }
);